import { HttpRequest } from '../stores/types/types';
import { Entity } from '../types/interfaces';
import { LivekitIngressType } from '../stores/types/livekit';
import { buildSyncUrl, getSyncHeaders } from './utils';

export const GetLivekitSessionEntity = async (
	token: string,
	roomId: number,
): Promise<Entity | null> => {
	try {
		const url = buildSyncUrl(`v1/room/${roomId}/livekit/session`);
		const res = await fetch(url, {
			method: HttpRequest.Get,
			headers: getSyncHeaders(token),
		});
		if (res.status === 200) return await res.json();
		return null;
	} catch (error) {
		console.error(error);
		return null;
	}
};

export const GetLivekitIngressEntities = async (
	token: string,
	roomId: number,
): Promise<Entity[]> => {
	try {
		const url = buildSyncUrl(`v1/room/${roomId}/livekit/ingresses`);
		const res = await fetch(url, {
			method: HttpRequest.Get,
			headers: getSyncHeaders(token),
		});
		if (res.status === 200) return await res.json();
		return [];
	} catch (error) {
		console.error(error);
		return [];
	}
};

export const GetLivekitViewerToken = async (
	token: string,
	roomId: number,
): Promise<{ token: string; serverUrl: string } | null> => {
	try {
		const url = buildSyncUrl(`v1/room/${roomId}/livekit/viewer-token`);
		const res = await fetch(url, {
			method: HttpRequest.Get,
			headers: getSyncHeaders(token),
		});
		if (res.status === 200) return await res.json();
		return null;
	} catch (error) {
		console.error(error);
		return null;
	}
};

export const CreateLivekitIngress = async (
	token: string,
	roomId: number,
	type: LivekitIngressType,
): Promise<Entity | null> => {
	try {
		const url = buildSyncUrl(`v1/room/${roomId}/livekit/ingress`);
		const res = await fetch(url, {
			method: HttpRequest.Post,
			headers: getSyncHeaders(token),
			body: JSON.stringify({ type }),
		});
		if (res.status === 200) return await res.json();
		return null;
	} catch (error) {
		console.error(error);
		return null;
	}
};

export const DeleteLivekitIngress = async (
	token: string,
	roomId: number,
	ingressId: string,
): Promise<boolean> => {
	try {
		const url = buildSyncUrl(`v1/room/${roomId}/livekit/ingress/${ingressId}`);
		const res = await fetch(url, {
			method: HttpRequest.Delete,
			headers: getSyncHeaders(token),
		});
		return res.status === 200;
	} catch (error) {
		console.error(error);
		return false;
	}
};
